module.exports = __webpack_public_path__ + "media/images/homes/VisualTableLayouts-a6d7f6b6d72711090e6d0e951116545b.png";